import React from "react";
import { Link } from "react-router-dom";
import Projects from "../../api/gallery";
import SectionTitle from "../SectionTitle/SectionTitle";



const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ProjectSectionHome = (props) => {
    const { hclass, ShowSectionTitle = true, sliceStart = 0, sliceEnd = 3, } = props;
    return (
        <section className={hclass}>
            <div className="container">
                {ShowSectionTitle && (
                <div className="row align-items-center">
                    <div className="col-lg-12 col-12">
                        <SectionTitle title={'Nuestros espacios'} subtitle={'Todo en un solo lugar'} />
                    </div>
                </div>
                )}
                <div className="project_wrapper">
                    <div className="row">
                        {Projects.slice(sliceStart, sliceEnd,).map((project, pitem) => (
                            <div className="col-lg-4 col-md-6 col-12" key={pitem}>
                                <div className="project_card">
                                    <img src={project.pimg1} alt="" />
                                    <div className="text">
                                        <h2><Link onClick={ClickHandler} to={`/about`}>{project.title}</Link></h2>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
export default ProjectSectionHome;





